import { render, staticRenderFns } from "./importProduct.vue?vue&type=template&id=f63b3c32&"
import script from "./importProduct.vue?vue&type=script&lang=js&"
export * from "./importProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports